import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { fuseAnimations } from '@fuse/animations';
import { SessionLog } from 'app/models/session-log.model';
import { User } from 'app/models/user.model';
import { LogsService } from 'app/services/logs.service';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
    selector: 'session-log',
    templateUrl: './session-log.component.html',
    styleUrls: ['./session-log.component.scss'],
    encapsulation: ViewEncapsulation.None,
    animations: fuseAnimations
})
export class SessionLogComponent implements OnInit {


    @ViewChild(MatSort) private _sort: MatSort;
    @ViewChild(MatPaginator) private _paginator: MatPaginator;

    private _sessionList: Array<SessionLog> = [];
    public get sessionList(): Array<SessionLog> {
        return this._sessionList;
    }
    private _filterText: string = '';
    public get filterText(): string {
        return this._filterText;
    }
    public set filterText(v: string) {
        this._filterText = v.trim().toLowerCase();
        this._dataSource.filter = this._filterText;
    }
    private _dataSource: MatTableDataSource<SessionLog> = undefined;
    public get dataSource(): MatTableDataSource<SessionLog> {
        return this._dataSource;
    }

    private _displayedColumns = ['username', 'ipAddress', 'browser', 'date','setting'];

    public get displayedColumns(): Array<string> {
        return this._displayedColumns;
    }
    
    constructor(private _logsService: LogsService, private _spinner:NgxSpinnerService) {
    }
    
    public async ngOnInit() {
        await this.getSessionList();
        this.updateTableDataSource();
    }
    private async getSessionList(): Promise<Array<SessionLog>> {
        try {
            this._spinner.show('loading')
            this._sessionList = await this._logsService.getSession(parseInt(localStorage.getItem("CompanyID")));
            this._spinner.hide('loading')
        } catch (error) {
            this._spinner.hide('loading')
            console.warn(error);
            return [];
        }
         this.updateTableDataSource();
    }
    deleteSession(session:SessionLog){
        try {
            
            this._logsService.deleteSession(session);
        this.refresh();

        } catch (error) {
            this._spinner.hide('loading')
            console.warn(error);
        }
        this.refresh();
    }
    async refresh(){
        await this.getSessionList();
    }
    private async updateTableDataSource(): Promise<void> {
        this._dataSource = new MatTableDataSource<SessionLog>(this._sessionList);
        this._dataSource.paginator = this._paginator;
        this._dataSource.sort = this._sort;
    }

}
